var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDirectory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffdf00",
    d: "M1 28V4a3 3 0 0 1 3-3h11.15a3 3 0 0 1 2.68 1.66l1.62 3.23A2 2 0 0 0 21.24 7H48a3 3 0 0 1 3 3v1z",
    opacity: 1,
    "data-original": "#ffdf00"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec108",
    d: "M48 7h-3a3 3 0 0 1 3 3v1L1 26.98V28l50-17v-1a3 3 0 0 0-3-3zM14.83 2.66l1.62 3.23A2 2 0 0 0 18.24 7h3a2 2 0 0 1-1.79-1.11l-1.62-3.23A3 3 0 0 0 15.15 1h-3a3 3 0 0 1 2.68 1.66z",
    opacity: 1,
    "data-original": "#fec108"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdf00",
    d: "M5 23h50a4 4 0 0 1 4 4v26a6 6 0 0 1-6 6H7a6 6 0 0 1-6-6V27a4 4 0 0 1 4-4z",
    opacity: 1,
    "data-original": "#ffdf00"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec108",
    d: "M55 23h-3a4 4 0 0 1 4 4v26a6 6 0 0 1-6 6h3a6 6 0 0 0 6-6V27a4 4 0 0 0-4-4z",
    opacity: 1,
    "data-original": "#fec108"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M8 11h44a3 3 0 0 1 3 3v9H5v-9a3 3 0 0 1 3-3z",
    opacity: 1,
    "data-original": "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Icons copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56 22.1V14a4 4 0 0 0-4-4 4 4 0 0 0-4-4H21.24a1 1 0 0 1-.9-.558l-1.615-3.229A3.977 3.977 0 0 0 15.15 0H4a4 4 0 0 0-4 4v49a7.008 7.008 0 0 0 7 7h46a7.008 7.008 0 0 0 7-7V27a5.009 5.009 0 0 0-4-4.9zM54 14v8H6v-8a2 2 0 0 1 2-2h44a2 2 0 0 1 2 2zM4 2h11.15a1.989 1.989 0 0 1 1.787 1.108l1.619 3.229A2.986 2.986 0 0 0 21.24 8H48a2 2 0 0 1 2 2H8a4 4 0 0 0-4 4v8.1a4.954 4.954 0 0 0-2 .925V4a2 2 0 0 1 2-2zm54 51a5.006 5.006 0 0 1-5 5H7a5.006 5.006 0 0 1-5-5V27a3 3 0 0 1 3-3h50a3 3 0 0 1 3 3z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectory);
export default __webpack_public_path__ + "static/media/directory.31b1e34cc366cf73683815822e9ff7e7.svg";
export { ForwardRef as ReactComponent };